"use client";

import { Moon, Sun } from "lucide-react";

import { useThemeStore } from "@/store/theme-store";
import { cn } from "@/lib/utils/cn";
import { Button, IconButton } from "./button";

export type ThemeToggleProps = { className?: string; variant?: "default" | "icon" };

export function ThemeToggle({ className, variant = "default" }: ThemeToggleProps) {
  const theme = useThemeStore((state) => state.theme);
  const setTheme = useThemeStore((state) => state.setTheme);
  const dark = theme === "dark";
  const label = dark ? "Switch to light theme" : "Switch to dark theme";
  const icon = dark ? <Sun className="h-4 w-4" aria-hidden /> : <Moon className="h-4 w-4" aria-hidden />;
  const toggle = () => setTheme(dark ? "light" : "dark");
  if (variant === "icon") {
    return <IconButton variant="secondary" aria-label={label} className={className} onClick={toggle}>{icon}</IconButton>;
  }
  return <Button variant="ghost" size="sm" aria-label={label} className={cn("text-muted", className)} onClick={toggle}>{icon}{dark ? "Light" : "Dark"}</Button>;
}
